import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import classnames from 'classnames';
import moment from 'moment';
import { Icon } from 'antd';

import { getUserGroups } from 'modules/authentication';
import { hasGroup } from 'helpers/permissionsHelpers';
import styles from './RequestTitle.module.scss';

const RequestTitle = ({ data, remind, userGroups }) => {
  const { title, userrequest } = data;
  let ownerName = null;

  if (hasGroup(userGroups, 'staff')) {
    const { firstname, lastname } = userrequest.owner.properties.contacts[0];
    ownerName = `${firstname} ${lastname}`;
  }

  // Get the diff between now and limit expiration date
  const now = moment();
  const expiry = moment(userrequest.expiry);
  const hasWarning = now.diff(expiry, 'd') >= -remind && now.diff(expiry, 'd') < 0;
  const isInternal = data[0] === 'N1' || data[0] === 'N2';
  return (
    <Link
      to={`/manage-request/detail/${userrequest.id}`}
      className={classnames({ [styles.new]: userrequest.has_new_changes })}
    >
      {hasWarning && isInternal && (
        <p className={styles.warning}>
          <Icon type="warning" /> Cette demande arrive à expiration
        </p>
      )}
      {title}
      {ownerName && <span className={styles.owner}>{ownerName}</span>}
    </Link>
  );
};

const mapStateToProps = (state, ownProp) => ({
  remind: state.appConfig.REMIND_DELTA_DAYS,
  userGroups: getUserGroups(state),
  data: ownProp,
});

export default connect(mapStateToProps, null)(RequestTitle);



// WEBPACK FOOTER //
// ./src/components/Userrequest/RequestTitle.js